import I18n from 'Pods/Shared/I18n'

export const EDIT_WITH_AI_LABEL = 'Edit with AI'

const ARCHIVE_FILE_KEY_PREFIX = 'profile.my_purchases.archive_file'

const translateArchiveFile = key => I18n.t(`${ARCHIVE_FILE_KEY_PREFIX}.${key}`, { ns: 'rails' })

export const buildArchiveFileLabels = () => ({
  title: translateArchiveFile('title'),
  description: translateArchiveFile('description'),
  listLabel: translateArchiveFile('list_label'),
  submit: translateArchiveFile('submit'),
  cancel: translateArchiveFile('cancel'),
})

const OPEN_ERROR_KEY_PREFIX = 'profile.my_purchases.open_error'
// The generator API answers in English only, so its known refusals are recognized by text.
const NO_COMPATIBLE_FILE = 'This model has no GLB, glTF, FBX, OBJ or STL file that can be used in the generator.'
const FILE_TOO_LARGE = /^This model's files exceed the (\d+)MB generator limit\.$/

export const translateOpenError = (serverMessage) => {
  const tooLarge = serverMessage?.match(FILE_TOO_LARGE)
  if (tooLarge) return I18n.t(`${OPEN_ERROR_KEY_PREFIX}.file_too_large`, { ns: 'rails', limit: tooLarge[1] })

  const key = serverMessage === NO_COMPATIBLE_FILE ? 'no_compatible_file' : 'generic'
  return I18n.t(`${OPEN_ERROR_KEY_PREFIX}.${key}`, { ns: 'rails' })
}
